import Cookies from 'js-cookie';
import _ from 'lodash';
import { Store } from 'vuex';
import i18n, { i18n_t } from '@/locales/i18n';
import { IS_BROWSER } from '@/common/constant/platform';
import storage from '@/renderer/scripts/utils/storage/index';
import smh, { SMH } from '@/renderer/scripts/smh';
import VistorEventBus from './vistorEventBus';
import { loginVistorWithCookie } from '../user/userLogin';
export interface VistorInfo {
  vistorPhoneNumber: string | undefined;
  vistorUserToken: string;
  isVistorLogined?: boolean;
}
export const defaultVistorInfo: VistorInfo = {
  vistorPhoneNumber: '',
  vistorUserToken: '',
  isVistorLogined: false,
};
const initStoreGetters = {
  isVistorLogined: false,
  collectToken: '',
  vistorPhoneNumber: '',
};
class VistorClass extends VistorEventBus {
  private changeRoute: (params: any) => void;
  private store:
    | Store<any>
    | {
        commit: Function;
        getters: Object;
      };
  public info: VistorInfo;
  constructor() {
    super();
    this.changeRoute = _.noop;
    this.info = _.cloneDeep(defaultVistorInfo);
    this.store = {
      commit: _.noop,
      getters: initStoreGetters,
    };
    this.initVistorInfo();
    // userReporter.init(this);
  }

  onLogined() {
    // 成功登录
    /* i18n-ignore*/
    logger.ui('游客登录成功...');
    reporter.report('login', {
      login_scenes: 'link_view',
      user_type: 'tourists',
    });
    storage.set(storage.StoreKey.VISTOR_LOGIN, {
      isLogined: true,
    });
    this.emit('after-vistor-login');
  }
  onLogout() {
    try {
      // 用户退出登录
      /* i18n-ignore*/
      logger.ui('游客退出登录...');
      storage.del(storage.StoreKey.VISTOR_LOGIN);
      // todo 完善退出登录的功能
      const vistorUserToken = Cookies.get('VISTOR_USER_TOKEN');
      smh.api.vistorLogout(vistorUserToken);
      Cookies.remove('VISTOR_USER_TOKEN');
      Cookies.remove('VISTOR_PHONE_NUMBER');
      this.store.commit('SET_VISTOR_LOGINED', false);
      this.store.commit('SET_VISTOR_PHONE_NUMBER', '');
      this.emit('after-vistor-logout');
    } catch (e: MsgError) {
      logger.ui.error('[vistor] vistorLogout error', JSON.stringify(e));
    } finally {
      this.info = _.cloneDeep(defaultVistorInfo);
    }
  }

  // 还原cookie的游客信息
  initVistorInfo() {
    try {
      logger.ui('[vistor] initVistorInfo');
      if (IS_BROWSER) {
        const vistorUserToken = Cookies.get('VISTOR_USER_TOKEN') || '';
        const vistorPhoneNumber = Cookies.get('VISTOR_PHONE_NUMBER') || '';
        if (_.isEmpty(vistorUserToken) || _.isEmpty(vistorPhoneNumber)) return;
        this.setVistorInfo({
          isVistorLogined: true,
          vistorUserToken,
          vistorPhoneNumber,
        });
        if (!vistorUserToken) return;
        this.info = {
          isVistorLogined: true,
          vistorUserToken,
          vistorPhoneNumber,
        };
      }
    } catch (e) {
      logger.ui.error('[vistor] initVistorInfo error', JSON.stringify(e));
      this.info = _.cloneDeep(defaultVistorInfo);
    }
  }

  // 设置游客信息
  setVistorInfo(vistorInfo: VistorInfo) {
    this.info = _.cloneDeep(vistorInfo);
    this.commitStore(vistorInfo);
    // 设置cookie
    if (IS_BROWSER && vistorInfo.vistorUserToken) {
      const phoneNumber = vistorInfo.vistorPhoneNumber;
      Cookies.set('VISTOR_USER_TOKEN', vistorInfo.vistorUserToken, {
        expires: 1,
      });
      phoneNumber &&
        Cookies.set('VISTOR_PHONE_NUMBER', phoneNumber, {
          expires: 1,
        });
    }
  }

  // 向vistor store同步数据
  private commitStore(vistorInfo: VistorInfo) {
    setTimeout(() => {
      this.store.commit('SET_VISTOR_LOGINED', true);
      this.store.commit('SET_VISTOR_PHONE_NUMBER', vistorInfo.vistorPhoneNumber);
    }, 0);
  }
  public setStoreFn(store: Store<any>) {
    this.store = store;
  }

  // 获取扁平数据结构(已知登录没有完成时，可以调用这里。比如验证成功但没有选择企业时)
  public getVistorInfoSync(): VistorInfo {
    if (IS_BROWSER) {
      const vistorUserToken = Cookies.get('VISTOR_USER_TOKEN') || '';
      return _.cloneDeep({
        ...this.info,
        vistorUserToken,
      });
    }
    return _.cloneDeep({
      ...this.info,
    });
  }

  // 获取扁平数据结构(已知登录已经完成时，需要用户登录态时调用)
  public getUserInfo(): VistorInfo {
    const info = this.getVistorInfoSync();
    const userInfoIsNotComplete = !info.vistorPhoneNumber || !info.vistorUserToken;
    if (userInfoIsNotComplete) {
      this.initVistorInfo();
    }
    return info;
  }

  /**
   * 账号验证完成获得userToken，开始选择企业并完成登录
   * */
  public verifyAndLogin(vistorInfo: VistorInfo) {
    vistorInfo.isVistorLogined = true;
    this.setVistorInfo(vistorInfo);
    this.onLogined();
  }
  public async resetVistorInfoFromLogin() {
    try {
      // 网盘用户和游客区分开
      if (Cookies.get('USER_TOKEN')) {
        Cookies.remove('VISTOR_USER_TOKEN');
        Cookies.remove('VISTOR_PHONE_NUMBER');
        return;
      }
      const { pathname } = window.location;
      // 游客自动登录(文件收集页面、分享外链页面)
      if (Cookies.get('VISTOR_USER_TOKEN')) {
        if (pathname.includes('/web/collect')) {
          this.store.commit('setLoginingMask', true);
          loginVistorWithCookie();
          return;
        }
        if (pathname.includes('/web/share')) {
          const shareToken = pathname.substr(pathname.lastIndexOf('/') + 1, pathname.length);
          const { data } = await smh.userAPI.getSharedLinkDetail({
            shareToken,
          });
          const { enableShareWatermark, shareWatermarkType } = data;
          if (enableShareWatermark && shareWatermarkType === 0) {
            this.store.commit('setLoginingMask', true);
            loginVistorWithCookie();
            return;
          }
        }
      }
    } catch (e: MsgError) {
      logger.ui('[Init VistorData] error:', e);
      return;
    }
  }
}
const vistor = new VistorClass();
export default vistor;
export { VistorClass };
